import React, { Component, Fragment } from 'react';
import { Box, Grid, Link, IconButton  } from '@material-ui/core';
import { Launch  } from '@material-ui/icons';
import webstoreLogo from '../../../Common/webstoreLogo';
import edgestoreLogo from '../../../Common/edgeStoreLogo';
import addinLogo from '../../../Common/addinLogo';

const openInNewTab = (url) => { window.open(url, "_blank", "noreferrer"); };
const webstoreUrl = "https://chrome.google.com/webstore/detail/bjfhkjgmnlabpopcmgagbdgjfelndpfj";
const edgestoreUrl = "https://microsoftedge.microsoft.com/addons/detail/moajkmbnajhhaojofiknkcdfapfkdjej";
const edgestoreKBUrl = "https://help.flowtrace.co/en/articles/8486124-meeting-cost-for-outlook-edge-extension";
const webstoreKBUrl = "https://help.flowtrace.co/en/articles/8198383-meeting-cost-for-google-calendar-chrome-extension";
const addinUrl = "https://api.flowtrace.io/outlook/manifest.xml";
const addinKBUrl = "https://help.flowtrace.co/en/articles/8850883-installing-flowtrace-meeting-costs-for-outlook-add-in";

const webStore = <IconButton id={"getFromWebStore"} onClick={() => openInNewTab(webstoreUrl)}>
    <Box component="img" src={webstoreLogo.src} alt={"Get it from Google Chrome Web Store"} sx={{ height: "50px", width: "auto" }} />
  </IconButton>;
const edgeStore = <IconButton id={"getFromEdgeStore"} onClick={() => openInNewTab(edgestoreUrl)}>
    <Box component="img" src={edgestoreLogo.src} alt={"Get it from Microsoft Edge Web Store"} sx={{ height: "50px", width: "auto" }} />
  </IconButton>;
const addinStore = <IconButton id={"getAddIn"} onClick={() => openInNewTab(addinUrl)}>
    <Box component="img" src={addinLogo.src} alt={"Outlook Add In via administrator portal"} sx={{ height: "50px", width: "auto" }} />
  </IconButton>;
const storeLinksAndInstructions =
  <Grid item xs={12}>
    <Grid container spacing={1}>
      <Grid item>
        <Grid container spacing={1} >
          <Grid item xs={12} sm={12}>
            <Link underline="hover" variant="body2" target={"_blank"} href={webstoreKBUrl}>Google Calendar Instructions <Launch fontSize="small"/></Link>;
          </Grid>
          <Grid item xs={12} sm={12}>
            {webStore}
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container spacing={1} >
          <Grid item xs={12} sm={12}>
            <Link underline="hover" variant="body2" target={"_blank"} href={addinKBUrl}>Outlook Add-In Instructions <Launch fontSize="small"/></Link>;
          </Grid>
          <Grid item xs={12} sm={12}>
            {addinStore}
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container spacing={1} >
          <Grid item xs={12} sm={12}>
            <Link underline="hover" variant="body2" target={"_blank"} href={edgestoreKBUrl}>Outlook Web & Edge Instructions <Launch fontSize="small"/></Link>;
          </Grid>
          <Grid item xs={12} sm={12}>
            {edgeStore}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Grid>;


class AppSettingStoreLinks extends Component {
  render() {
    if (this.props.loading)
      return this.props.loading();

    return (
      <Fragment>
              {storeLinksAndInstructions}
      </Fragment>
    );
  }
}

export default AppSettingStoreLinks;
